<template>
  <v-card elevation="2" height="100%">
    <v-card-text>
      <h2 v-if="!hideTitle" class="display-1 mb-4">Time Ordered</h2>
      <v-layout
        jusitify-space-between
        :row="layout == 'bar'"
        :column="layout != 'bar'"
      >
        <v-flex shrink>
          <v-autocomplete
            label="Worksite"
            :items="selectableWorksites"
            item-text="name"
            item-value="id"
            v-model="worksiteID"
            @change="
              managerID = null;
              clientIDs = [];
            "
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex class="mr-2">
          <v-autocomplete
            label="Manager"
            :items="selectableManagers"
            item-text="name"
            item-value="id"
            v-model="managerID"
            @change="
              worksiteID = null;
              clientIDs = [];
            "
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex class="mr-2">
          <v-autocomplete
            label="Clients"
            multiple
            chips
            :items="selectableClients"
            item-text="name"
            item-value="id"
            v-model="clientIDs"
            @change="
              worksiteID = null;
              managerID = null;
            "
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex class="ml-2" shrink>
          <v-select
            v-model="timePeriod"
            :items="timePeriodItems"
            item-text="name"
            item-value="param"
            label="Time Period"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-layout justify-end>
          <v-btn
            @click="getRecords"
            :disabled="!allChoicesMade"
            color="primary"
          >
            {{ buttonText }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import collectionApi from "@/api/collections";

export default {
  components: {},
  computed: {
    ...mapState("userAuth", ["user"])
  },
  created() {
    this.getWorksites();
    this.getManagers();
    this.getClients();
  },
  props: {
    hideTitle: {
      default: false,
      type: Boolean
    },
    layout: {
      default: "",
      type: String
    },
    buttonText: {
      default: "Get Report",
      type: String
    }
  },
  data: function() {
    return {
      selectableWorksites: [],
      selectableManagers: [],
      selectableClients: [],
      clientIDs: [],
      worksiteID: null,
      managerID: null,
      timePeriod: "quarter",
      timePeriodItems: [
        {
          name: "Total",
          param: "total"
        },
        {
          name: "By Year",
          param: "year"
        },
        {
          name: "By Quarter",
          param: "quarter"
        },
        {
          name: "By Month",
          param: "month"
        }
      ]
    };
  },
  computed: {
    allChoicesMade: function() {
      return true;
    }
  },
  methods: {
    getRecords: function() {
      this.$router.push({
        name: "allTimeOrderedReport",
        query: {
          period: this.timePeriod,
          worksiteID: this.worksiteID,
          managerID: this.managerID,
          clientIDs: this.clientIDs
        }
      });
    },

    getWorksites() {
      if (this.selectableWorksites.length === 0) {
        this.apiCallPending = true;
        collectionApi.getLocations(worksites => {
          this.selectableWorksites = worksites;
          this.apiCallPending = false;
        });
      }
    },

    getManagers() {
      if (this.selectableManagers.length === 0) {
        this.apiCallPending = true;
        collectionApi.getManagersList({}, managers => {
          this.selectableManagers = managers;
          this.apiCallPending = false;
        });
      }
    },

    getClients() {
      if (this.selectableClients.length === 0) {
        this.apiCallPending = true;
        collectionApi.getClientBusinesses(clients => {
          this.selectableClients = clients;
          this.apiCallPending = false;
        });
      }
    },

    dateFormatted: function(date) {
      return date ? this.$moment(date).format("dddd, MMMM D") : "";
    }
  }
};
</script>
